// import React, { useRef, useState, useEffect, useCallback } from "react";
// import { _Api, _PdfApi } from "../../../components/api/_call";
// import "rc-slider/assets/index.css";
// import { Pagination } from "../../../components/common/Pagination";
// import {
//   loading,
//   Updateloading,
// } from "../../../components/common/helpers/toastify";
// import optionIcon from "../../../assets/images/icons/optionButton.png";
// import { useTranslation } from "react-i18next";
// import Select from "react-select";
// import TableLoader from "../../../admin/common/TableLoader";
// import traceimg from "../../../assets/images/TraceItem_diamond.svg";
// import { Link } from "react-router-dom";
// import { toast } from "react-toastify";
// import HeldCheckbox from "../../../components/common/modules/HeldCheckbox";

// const WarrantyInv = (props) => {
//   const { t } = useTranslation();
//   const dataFetched = useRef();
//   const colDropdownRefItem = useRef(null);
//   const colDropdownRefCollection = useRef(null);
//   const colDropdownRefMetal = useRef(null);
//   const colDropdownRefStone = useRef(null);
//   const colDropdownRefSize = useRef(null);
//   const colDropdownRefLocation = useRef(null);
//   const colDropdownRefStatus = useRef(null);
//   const stickyThRefs = useRef([]);
//   const viewDropdownRef = useRef(null);
//   const [stickyLefts, setStickyLefts] = useState([
//     0, 40, 80, 135, 250, 340, 445,
//   ]);
//   const [inventorylist, setInventorylist] = useState([]);
//   const [inventorycounts, setInventorycounts] = useState();
//   const [filterdata, setFilterdata] = useState();
//   const [showoption, setShowoption] = useState(false);
//   const [pdfLoading, setPdfLoading] = useState(false);
//   const [showpos, setShowpos] = useState([]);
//   const [transferlist, setTransferlist] = useState([]);
//   const [locationidlist, setLocationidlist] = useState([]);
//   const [showtransfer, setShowtransfer] = useState(false);
//   const [onlyTransfer, setOnlyTransfer] = useState(false);
//   const [filtername, setFiltername] = useState("");
//   const [limit, setLimit] = useState(100);
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
//   const [SelectAllStatus, setSelectAllStatus] = useState();
//   const [Selectlist, setSelectlist] = useState([]);
//   const [getoneproduct, setOneproduct] = useState();
//   const [imageid, setImageid] = useState();
//   const [selectedlocation, setSelectedlocation] = useState();
//   const [selectedwarehouse, setSelectedwarehouse] = useState("");
//   const [product_id, setProduct_id] = useState();
//   const [cart_id, setCart_id] = useState();
//   const [getSkipNumbers, setSkipNumbers] = useState(0);
//   const [datalodaer, setDatsLodaer] = useState(false);
//   const [isOptionClick, setIsOptionClick] = useState(false);
//   const [datatotal, setDatatotal] = useState({ amount: 0, qty: 0 });
//   const [traceData, setTraceData] = useState();
//   const [traceDetail, setTraceDetail] = useState({});
//   const [payload, setPayload] = useState();
//   const [invCount, setInvCount] = useState(0);
//   const [viewMode, setViewMode] = useState("table");
//   const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
//   const [colFilterOptions, setColFilterOptions] = useState({});
//   const fullInventoryRef = useRef([]);

//   const getStatusDotClass = (status) => {
//     const map = {
//       stock: "light-blue-bg",
//       transit: "green-bg",
//       warehouse: "status-gray-bg",
//       reserve: "yellow-bg",
//       repair_order: "purple-bg",
//       custom_order: "danger-bg",
//     };
//     return map[status] || "light-blue-bg";
//   };

//   const getStatusLabel = (status) => {
//     const map = {
//       stock: "Stock",
//       transit: "Transit",
//       warehouse: "Warehouse",
//       reserve: "Reserve",
//       repair_order: "Repair Order",
//       custom_order: "Custom Order",
//     };
//     return map[status] || status || "";
//   };

//   const [activeFilters, setActiveFilters] = useState({
//     item: [],
//     collection: [],
//     metal: [],
//     stone: [],
//     size: [],
//     location: [],
//     status: [],
//     price: [],
//   });
//   const [colFilterSearch, setColFilterSearch] = useState({
//     item: "",
//     collection: "",
//     metal: "",
//     stone: "",
//     size: "",
//     location: "",
//     status: "",
//   });

//   // const iconMap = {
//   //   "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
//   //   "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
//   //   "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
//   //   "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
//   //   "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
//   //   "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
//   //   "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
//   //   "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
//   //   "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
//   //   "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
//   //   "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
//   // };

//   // const getTimelineData = (data) => {
//   //   const timeline = [];

//   //   timeline.push({
//   //     id: "product_design",
//   //     name: "Product Design",
//   //     countries: [data?.product_design_trace ? data?.product_design_trace : []],
//   //     transactionId: data?.product_design_trace_detail?.transactionId || "-",
//   //     iconName: { icon: product_design, color: "#3C609C" },
//   //   });

//   //   const iconMapOrder = [
//   //     "652e2c3f7ab8c5b2750a4f03",
//   //     "652e2c3f7ab8c5b2750a4f04",
//   //     "652e2c3f7ab8c5b2750a4f05",
//   //     "652e2c3f7ab8c5b2750a4f08",
//   //     "652e2c3f7ab8c5b2750a4f09",
//   //     "652e2c3f7ab8c5b2750a4f06",
//   //     "652e2c3f7ab8c5b2750a4f07",
//   //     "652e2c3f7ab8c5b2750a4f0a",
//   //     "652e2c3f7ab8c5b2750a4f0b",
//   //     "652e2c3f7ab8c5b2750a4f0c",
//   //     "652e2c3f7ab8c5b2750a4f02",
//   //   ];

//   //   const orderedItems = iconMapOrder
//   //     .filter((key) => data.traceability[key])
//   //     .map((key) => ({
//   //       id: key,
//   //       ...data.traceability[key],
//   //       iconName: iconMap[key]
//   //         ? iconMap[key]
//   //         : {
//   //             icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
//   //             color: "#606060",
//   //           },
//   //     }));

//   //   const unorderedItems = Object.keys(data.traceability)
//   //     .filter((key) => !iconMapOrder.includes(key))
//   //     .map((key) => ({
//   //       id: key,
//   //       ...data.traceability[key],
//   //       iconName: iconMap[key]
//   //         ? iconMap[key]
//   //         : {
//   //             icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
//   //             color: "#606060",
//   //           },
//   //     }));

//   //   timeline.push(...orderedItems, ...unorderedItems);
//   //   return timeline;
//   // };

//   const selectOptions = [
//     { label: 100, value: 100 },
//     { label: 200, value: 200 },
//     { label: 300, value: 300 },
//   ];

//   const handleChange = (event) => {
//     if (event.target.checked) {
//       let posorderarray = [];
//       const selected = [...Selectlist];
//       const mainarray = [...inventorylist];
//       const transferarray = [...transferlist];
//       const locationarray = [...locationidlist];
//       let checking = document.querySelectorAll(".inventorytablecheck");
//       let hasOnlyTransfer = false;
//       for (let i = 0; i < checking.length; i++) {
//         if (checking[i].checked) {
//           posorderarray.push(i);
//           setShowoption(true);
//           // if (
//           //   checking[i].getAttribute("data-status") === "reserve" &&
//           //   checking[i].getAttribute("data-isnottransferable") === "false"
//           // ) {
//           //   hasOnlyTransfer = true;
//           // }
//         }
//         setShowpos(posorderarray);
//       }
//       setOnlyTransfer(hasOnlyTransfer);
//       if (selected.filter((e) => e === event.target.id).length === 0) {
//         selected.push(event.target.id);
//       }
//       setSelectlist(selected);
//       const currentid = mainarray.filter((all) => all.id === event.target.id);
//       setSelectedlocation(currentid[0]?.location_id);
//       setSelectedwarehouse(
//         currentid[0]?.warehouse_id ? currentid[0]?.warehouse_id : "null",
//       );
//       if (transferarray?.length === 0) {
//         setShowtransfer(true);
//         locationarray.push(currentid[0]?.location_id);
//         setLocationidlist(locationarray);
//         transferarray.push(event.target.id);
//         setTransferlist(transferarray);
//       } else {
//         const checkloc = locationarray.filter(
//           (locid) => locid === currentid[0]?.location_id,
//         );
//         if (checkloc?.length) {
//           transferarray.push(event.target.id);
//           setShowtransfer(true);
//           setTransferlist(transferarray);
//         } else {
//           setShowtransfer(false);
//         }
//       }
//     } else {
//       let array = [];
//       let posorderarray = [];
//       const mainarray = [...inventorylist];
//       const transferarray = [...transferlist];
//       const locationarray = [...locationidlist];
//       let checking = document.querySelectorAll(".inventorytablecheck");
//       let hasOnlyTransfer = false;
//       for (let i = 0; i < checking.length; i++) {
//         if (checking[i].checked) {
//           array.push(i);
//           posorderarray.push(i);
//           setShowoption(true);
//           // if (
//           //   checking[i].getAttribute("data-status") === "reserve" &&
//           //   checking[i].getAttribute("data-isnottransferable") === "false"
//           // ) {
//           //   hasOnlyTransfer = true;
//           // }
//         }
//         setShowpos(posorderarray);
//       }
//       setOnlyTransfer(hasOnlyTransfer);
//       setSelectlist((current) =>
//         current.filter((item) => item !== event.target.id),
//       );
//       if (array.length === 0) {
//         setShowoption(false);
//         setOnlyTransfer(false);
//       }
//       const currentid = mainarray.filter((all) => all.id === event.target.id);
//       if (transferarray?.length === 1) {
//         setLocationidlist((current) =>
//           current.filter((item) => item !== currentid[0]?.location_id),
//         );
//         setTransferlist((current) =>
//           current.filter((item) => item !== event.target.id),
//         );
//         setShowtransfer(true);
//         setSelectedlocation("");
//         setSelectedwarehouse("");
//       } else {
//         const checkloc = locationarray.filter(
//           (locid) => locid === currentid[0]?.location_id,
//         );
//         if (checkloc?.length) {
//           setTransferlist((current) =>
//             current.filter((item) => item !== event.target.id),
//           );
//           var callcheck = document.querySelectorAll(".inventorytablecheck");
//           for (var i = 0; i < callcheck.length; i++) {
//             if (callcheck[i].checked) {
//               let locationid = callcheck[i].getAttribute("data-locationid");
//               const notmatch = locationarray.filter(
//                 (locid) => locid !== locationid,
//               );
//               if (notmatch.length) {
//                 setShowtransfer(false);
//               } else {
//                 setShowtransfer(true);
//               }
//             }
//           }
//         } else {
//           if (transferarray?.length) {
//             setShowtransfer(true);
//           } else {
//             setShowtransfer(false);
//           }
//         }
//       }
//     }
//   };

//   const inventorycountsapi = async (filter, search) => {
//     try {
//       const postdata = { location: filter?.location ? filter?.location : [] };
//       let res = await _Api(postdata, `api/v1/Inventory/my/inventory-statics`);
//       if (res?.code === 200) {
//         setInventorycounts(res?.data);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const inventorylowercount = async (filter, search, limit) => {
//     try {
//       const postdata = {
//         item: filter?.item ? filter?.item : [],
//         collection: filter?.collection ? filter?.collection : [],
//         metal: filter?.metal ? filter?.metal : [],
//         size: filter?.size ? filter?.size : [],
//         stone: filter?.stone ? filter?.stone : [],
//         productStatus: filter?.status ? filter?.status : [],
//         location: filter?.location ? filter?.location : [],
//         price: filter?.price ? filter?.price : [],
//         search: search === "" ? search : filtername,
//         limit: limit,
//         allocated: filter?.allocated ? filter?.allocated : false,
//         traced: filter?.traced ? filter?.traced : false,
//       };
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/my/inventory-lowerStatics`,
//       );
//       if (res?.code === 200) {
//         setDatatotal(res?.data);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const filterbyname = (search) => {
//     setstate({ ...state, currentPage: 1 });
//     Getmyinventory(1, limit, filterdata, search, 0);
//   };

//   const getlimit = (limit) => {
//     setLimit(limit);
//     Getmyinventory(1, limit, filterdata);
//     setstate({ ...state, currentPage: 1 });
//   };

//   const [state, setstate] = useState({ totalPages: 20, currentPage: 1 });
//   const { totalPages, currentPage } = state;

//   const handlePaginations = (current) => {
//     setstate({ ...state, currentPage: current });
//     Getmyinventory(current, "", filterdata);
//   };

//   const Getmyinventory = useCallback(
//     async (current, firstlimit, filter, search, skip) => {
//       let tablelimit = 1;
//       if (firstlimit === "ALL") {
//         tablelimit = 1;
//       } else {
//         tablelimit = firstlimit ? firstlimit : limit;
//       }
//       setDatsLodaer(true);
//       var skipNumber = current ? (current - 1) * tablelimit : 0;
//       if (skip === 0 || skipNumber === 0) {
//         inventorycountsapi(filter, search);
//       }
//       setInvCount(0);
//       try {
//         const postdata = {
//           item: filter?.item ? filter?.item : [],
//           collection: filter?.collection ? filter?.collection : [],
//           metal: filter?.metal ? filter?.metal : [],
//           size: filter?.size ? filter?.size : [],
//           stone: filter?.stone ? filter?.stone : [],
//           productStatus: filter?.status ? filter?.status : [],
//           location: filter?.location ? filter?.location : [],
//           price: filter?.price ? filter?.price : [],
//           search: search === "" ? search : filtername,
//           limit: firstlimit ? firstlimit : limit,
//           skip: skip === 0 ? skip : skipNumber,
//           allocated: filter?.allocated ? filter?.allocated : false,
//           traced: filter?.traced ? filter?.traced : false,
//         };
//         setPayload(postdata);
//         let resPoinventory = await _Api(postdata, `api/v1/Inventory/my/list`);
//         if (resPoinventory?.code === 200) {
//           setFilterdata(filter);
//           setSelectAllStatus(false);
//           setDatsLodaer(false);
//           setSkipNumbers(skip === 0 ? skip : skipNumber);
//           let pageini = 1;
//           if (postdata.limit === "ALL") {
//             pageini = resPoinventory?.total;
//           } else {
//             pageini = postdata.limit;
//           }
//           setstate({
//             ...state,
//             totalPages: Math.ceil(resPoinventory?.total / pageini),
//             currentPage: current ? current : 1,
//           });
//           setInventorylist(resPoinventory?.data);
//           fullInventoryRef.current = resPoinventory?.data;
//           setInvCount(resPoinventory?.total);
//           inventorylowercount(
//             filter,
//             search,
//             parseInt(postdata?.limit) + parseInt(postdata?.skip),
//           );
//         }
//       } catch (err) {
//         console.log(err, "err");
//       }
//       // eslint-disable-next-line
//     },
//     [filtername, limit, state],
//   );

//   useEffect(() => {
//     if (dataFetched.current) return;
//     dataFetched.current = true;
//     Getmyinventory();
//     // eslint-disable-next-line
//   }, [Getmyinventory]);

//   // const handleTraceData = (key) => {
//   //   const mainarray = [...inventorylist];
//   //   const item = mainarray[key];
//   //   const tracesDetail = {
//   //     image: item?.main_image || "",
//   //     name: item?.name || "",
//   //     SKU: item?.SKU || "",
//   //     pos_Qty: item?.po_QTY || 1,
//   //     stock_id: item?.stock_id || "-",
//   //     transactionId: item?.product_design_trace_detail?.transactionId,
//   //   };
//   //   setTraceDetail(tracesDetail);
//   //   const traceability = item?.traceability || {};
//   //   const product_design_trace = item?.product_design_trace || {
//   //     label: "Unknown",
//   //     value: "",
//   //   };
//   //   const product_design_trace_detail = item?.product_design_trace_detail || {
//   //     transactionId: "-",
//   //   };
//   //   const tracesData = {
//   //     traceability,
//   //     product_design_trace,
//   //     product_design_trace_detail,
//   //   };
//   //   const arrtrace = getTimelineData(tracesData);
//   //   setTraceData(arrtrace);
//   // };

//   // useEffect(() => {
//   //   if (SelectAllStatus) {
//   //     let callcheck = document.querySelectorAll(".inventorytablecheck");
//   //     const selected = [...Selectlist];
//   //     const transferarray = [...transferlist];
//   //     let location_id = [];
//   //     let warehouse_id = [];
//   //     for (let i = 0; i < callcheck.length; i++) {
//   //       let status = callcheck[i].getAttribute("data-status");
//   //       if (status === "reserve" || status === "transit") {
//   //         callcheck[i].checked = false;
//   //       }
//   //       if (callcheck[i].checked) {
//   //         let id = callcheck[i].getAttribute("data-id");
//   //         let location = callcheck[i].getAttribute("data-locationid");
//   //         let warehouse = callcheck[i].getAttribute("warehouse_id");
//   //         location_id.push(location);
//   //         warehouse_id.push(warehouse);
//   //         if (selected.indexOf(id) === -1) {
//   //           selected.push(id);
//   //         }
//   //         const array = Array.from(
//   //           new Set(inventorylist.map((item) => item.location_id)),
//   //         );
//   //         if (array?.length === 1) {
//   //           setShowtransfer(true);
//   //           transferarray.push(id);
//   //         }
//   //       }
//   //     }
//   //     setSelectedlocation(location_id[0]);
//   //     if (warehouse_id[0]) {
//   //       setSelectedwarehouse(warehouse_id[0]);
//   //     } else {
//   //       setSelectedwarehouse("null");
//   //     }
//   //     setTransferlist(transferarray);
//   //     setSelectlist(selected);
//   //   } else {
//   //     let callcheck = document.querySelectorAll(".inventorytablecheck");
//   //     let newSelectlist = [...Selectlist];
//   //     let newTransferlist = [...transferlist];
//   //     for (let i = 0; i < callcheck.length; i++) {
//   //       let id = callcheck[i].getAttribute("data-id");
//   //       newSelectlist = newSelectlist.filter((item) => item !== id);
//   //       newTransferlist = newTransferlist.filter((item) => item !== id);
//   //     }
//   //     setSelectlist(newSelectlist);
//   //     setTransferlist(newTransferlist);
//   //   }
//   //   // eslint-disable-next-line
//   // }, [SelectAllStatus, inventorylist]);

//   useEffect(() => {
//     if (SelectAllStatus) {
//       const selected = [];
//       const transferarray = [];
//       const location_id = [];
//       const warehouse_id = [];

//       let callcheck = document.querySelectorAll(".inventorytablecheck");
//       for (let i = 0; i < callcheck.length; i++) {
//         // Rows held for Stock Adjustment can't be selected, even via "select all".
//         const isHeld = callcheck[i].getAttribute("data-isadjustmentheld") === "true";
//         if (isHeld) {
//           callcheck[i].checked = false;
//           continue;
//         }
//         callcheck[i].checked = true;

//         const id = callcheck[i].getAttribute("data-id");
//         const location = callcheck[i].getAttribute("data-locationid");
//         const warehouse = callcheck[i].getAttribute("warehouse_id");

//         location_id.push(location);
//         warehouse_id.push(warehouse);
//         if (id && !selected.includes(id)) selected.push(id);
//         transferarray.push(id);
//       }

//       setSelectedlocation(location_id[0]);
//       setSelectedwarehouse(warehouse_id[0] || "null");
//       setTransferlist(transferarray);
//       setSelectlist(selected);
//       setShowoption(selected.length > 0);

//       const uniqueLocs = Array.from(new Set(location_id));
//       setShowtransfer(uniqueLocs.length === 1);
//     } else {
//       // Uncheck all DOM checkboxes
//       document.querySelectorAll(".inventorytablecheck").forEach((cb) => {
//         cb.checked = false;
//       });
//       setSelectlist([]);
//       setTransferlist([]);
//       setLocationidlist([]);
//       setShowoption(false);
//       setShowtransfer(false);
//     }
//   }, [SelectAllStatus, inventorylist]);
//   useEffect(() => {
//     const allCheckboxes = document.querySelectorAll(".inventorytablecheck");
//     if (allCheckboxes.length === 0) return;

//     // Rows held for Stock Adjustment are never selectable, so they must be
//     // excluded from the "all selected" count too — otherwise the header
//     // checkbox could never show as checked while any row is held.
//     const selectableCount = inventorylist.filter(
//       (r) => !r?.is_adjustment_held
//     ).length;
//     const allChecked =
//       selectableCount > 0 && Selectlist.length === selectableCount;

//     setSelectAllStatus(allChecked);
//   }, [Selectlist, inventorylist]);

//   useEffect(() => {
//     getColFilterOptions();
//   }, []);

//   useEffect(() => {
//     const computeStickyLefts = () => {
//       let acc = 0;
//       const lefts = stickyThRefs.current.map((th) => {
//         const left = acc;
//         if (th) acc += th.offsetWidth;
//         return left;
//       });
//       setStickyLefts(lefts);
//     };
//     computeStickyLefts();
//     window.addEventListener("resize", computeStickyLefts);
//     return () => window.removeEventListener("resize", computeStickyLefts);
//   }, [inventorylist]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         viewDropdownRef.current &&
//         !viewDropdownRef.current.contains(e.target)
//       ) {
//         setViewDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const getColFilterOptions = async () => {
//     try {
//       let res = await _Api(
//         { custom_filter_enable: true },
//         `api/v1/Inventory/my/filter`,
//       );
//       if (res?.code === 200) {
//         setColFilterOptions(res?.data);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   // Add this helper
//   const resetAllCheckboxes = () => {
//     document.querySelectorAll(".inventorytablecheck").forEach((cb) => {
//       cb.checked = false;
//     });
//     const headerCb = document.getElementById("th_comman_checkbox");
//     if (headerCb) headerCb.checked = false;
//     setSelectlist([]);
//     setSelectAllStatus(false);
//     setTransferlist([]);
//     setLocationidlist([]);
//     setShowoption(false);
//     setShowtransfer(false);
//   };

//   const handlePrintWarranty = async () => {
//     if (!Selectlist.length) {
//       toast.error("Please select at least one item to print.");
//       return;
//     }
//     setPdfLoading(true);
//     let GetloadingID = loading();
//     try {
//       const blobData = await _PdfApi(
//         {
//           po_product_ids: Selectlist,
//           website_url: window.location.hostname,
//           type: "",
//           skip_logo_fetch: true,
//         },
//         "api/v1/APP/warranty/print",
//       );
//       const blob = new Blob([blobData], { type: "application/pdf" });
//       const blobUrl = URL.createObjectURL(blob);
//       window.open(blobUrl, "_blank");

//       Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
//     } catch (err) {
//       console.error(err);
//       Updateloading(t, GetloadingID, "Failed to generate print.", "e");
//     } finally {
//       resetAllCheckboxes();
//       setPdfLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (isOptionClick) {
//       setInventorylist(
//         fullInventoryRef.current.filter((i) => i.warranty_print === true),
//       );
//     } else {
//       setInventorylist(fullInventoryRef.current);
//     }
//   }, [isOptionClick]);

//   const hendleColDropdownHide = (label) => {
//     const refMap = {
//       item: colDropdownRefItem,
//       collection: colDropdownRefCollection,
//       metal: colDropdownRefMetal,
//       stone: colDropdownRefStone,
//       size: colDropdownRefSize,
//       location: colDropdownRefLocation,
//       status: colDropdownRefStatus,
//     };
//     if (refMap[label]?.current) refMap[label].current.classList.remove("show");
//   };

//   const handleColFilterItemChange = (event, value, filterKey) => {
//     setActiveFilters((prev) => ({
//       ...prev,
//       [filterKey]: event.target.checked
//         ? [...prev[filterKey], value]
//         : prev[filterKey].filter((v) => v !== value),
//     }));
//   };

//   const handleColFilterSelectAll = (event, filterKey) => {
//     const isStatus = filterKey === "status";
//     const allValues = (colFilterOptions?.[filterKey] || []).map((o) =>
//       isStatus ? o.value : o._id,
//     );
//     setActiveFilters((prev) => ({
//       ...prev,
//       [filterKey]: event.target.checked ? allValues : [],
//     }));
//   };

//   const applyColFilter = (filterKey) => {
//     Getmyinventory(1, limit, activeFilters, filtername, 0);
//     hendleColDropdownHide(filterKey);
//   };

//   const renderColFilterDropdown = (filterKey, dropdownRef) => {
//     const isStatus = filterKey === "status";
//     const options = colFilterOptions?.[filterKey] || [];
//     const checkedVals = activeFilters[filterKey] || [];
//     const searchTerm = colFilterSearch[filterKey] || "";
//     const filteredOptions = searchTerm
//       ? options.filter((o) =>
//           o?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : options;
//     return (
//       <div className="dropdown d-inline-block com-custom-table-tag-filter">
//         <button
//           className="after-none bg-transparent border-0 dropdown-toggle p-0"
//           type="button"
//           data-bs-toggle="dropdown"
//           aria-expanded="false"
//           data-bs-auto-close="outside"
//           data-bs-strategy="fixed"
//         >
//           <img
//             className="ms-2 com-custom-table-tag-filter-img"
//             src={base_assets + "images/icons/table-filter-icon.png"}
//             alt=""
//           />
//         </button>
//         <div
//           className="dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"
//           ref={dropdownRef}
//         >
//           {!isStatus && (
//             <div className="com-custom-table-tag-filter-menu-search">
//               <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
//                 <img
//                   src={base_assets + "images/icons/search-icon.png"}
//                   alt=""
//                 />
//                 <input
//                   className="border-0"
//                   type="text"
//                   placeholder="Search"
//                   value={searchTerm}
//                   onChange={(e) =>
//                     setColFilterSearch((prev) => ({
//                       ...prev,
//                       [filterKey]: e.target.value,
//                     }))
//                   }
//                 />
//               </div>
//             </div>
//           )}
//           <div className="com-custom-table-tag-filter-menu-select">
//             <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
//               <div>
//                 <input
//                   className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
//                   type="checkbox"
//                   id={`colfilter-all-${filterKey}`}
//                   onChange={(e) => handleColFilterSelectAll(e, filterKey)}
//                   checked={
//                     options.length > 0 && checkedVals.length === options.length
//                   }
//                 />
//                 <label
//                   className="form-check-label cursor-pointer fw-semibold"
//                   htmlFor={`colfilter-all-${filterKey}`}
//                 >
//                   {t("Select All")}
//                 </label>
//               </div>
//               <label>
//                 {checkedVals.length}/{options.length} {t("Selected")}
//               </label>
//             </div>
//             <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
//               {filteredOptions.map((opt, idx) => {
//                 const val = isStatus ? opt.value : opt._id;
//                 const optId = `colfilter-${filterKey}-${idx}`;
//                 return (
//                   <li
//                     className="com-custom-table-tag-filter-menu-select-list-single"
//                     key={optId}
//                   >
//                     <input
//                       className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
//                       type="checkbox"
//                       id={optId}
//                       checked={checkedVals.includes(val)}
//                       onChange={(e) =>
//                         handleColFilterItemChange(e, val, filterKey)
//                       }
//                     />
//                     <label
//                       className="form-check-label cursor-pointer"
//                       htmlFor={optId}
//                     >
//                       {opt?.name}
//                     </label>
//                   </li>
//                 );
//               })}
//             </ul>
//           </div>
//           <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
//             <button
//               className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
//               onClick={() => {
//                 setActiveFilters((prev) => ({ ...prev, [filterKey]: [] }));
//                 setColFilterSearch((prev) => ({ ...prev, [filterKey]: "" }));
//               }}
//             >
//               {t("Clear")}
//             </button>
//             <button
//               className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
//               onClick={() => applyColFilter(filterKey)}
//             >
//               {t("Apply")}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <React.Fragment>
//       <div className="main-body my-inventory-page">
//         <div className="container" style={{ padding: "46px 46px 0px" }}>
//           <div className="row">
//             <div className="col-lg-12">
//               <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                 <Link to="/app/admin/setup/warranty">
//                   <img
//                     className="page-back-btn-inside-img"
//                     src={base_assets + "/images/icons/arrow-left.png"}
//                     alt="back"
//                     style={{
//                       width: "80%",
//                       height: "80%",
//                       objectFit: "contain",
//                     }}
//                   />
//                 </Link>
//                 <h1 className="main-body-heading">{t("Import Inventory")}</h1>
//               </div>

//               <div
//                 className="main-body-top-status-bar"
//                 style={{ marginTop: 50 }}
//               >
//                 <Select
//                   className="limit-select short"
//                   options={selectOptions}
//                   value={{ label: limit, value: limit }}
//                   onChange={(e) => {
//                     setLimit(e.value);
//                     getlimit(e.value);
//                   }}
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//                 />
//                 <div className="main-body-top-status-bar-filter">
//                   <input
//                     type="text"
//                     value={filtername}
//                     className="main-body-top-status-bar-filter-input"
//                     placeholder={t("SKU/StockID")}
//                     onKeyPress={(e) =>
//                       e.key === "Enter" && filterbyname(e.target.value)
//                     }
//                     onChange={(e) => setFiltername(e.target.value)}
//                   />
//                   <button
//                     onClick={filterbyname}
//                     className="main-body-top-status-bar-filter-search"
//                   >
//                     <i className="fa fa-search" aria-hidden="true" />
//                   </button>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     marginLeft: "auto",
//                     alignItems: "center",
//                     gap: 10,
//                   }}
//                 >
//                   <div className="tooltip-area-up">
//                     <div
//                       className="inventory-btn"
//                       style={{
//                         display: "flex",
//                         gap: "3px",
//                         fontSize: "14px",
//                         alignItems: "center",
//                         background: isOptionClick ? "#D8F3F2" : "transparent",
//                         border: isOptionClick ? "1px solid #62D0CB" : "unset",
//                         padding: isOptionClick ? "0px 12px" : "unset",
//                       }}
//                       onClick={() => setIsOptionClick(!isOptionClick)}
//                     >
//                       <img
//                         src={optionIcon}
//                         alt="logo"
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "contain",
//                           cursor: "pointer",
//                         }}
//                       />
//                       {isOptionClick
//                         ? fullInventoryRef.current.filter(
//                             (i) => i.warranty_print === true,
//                           )?.length
//                         : undefined}
//                     </div>
//                     <span className="tooltip-area-up-text">{t("Reprint Filter")}</span>
//                   </div>

//                   <div
//                     className="inventory-btn"
//                     onClick={() =>
//                       !pdfLoading ? handlePrintWarranty() : undefined
//                     }
//                     style={{
//                       opacity: Selectlist.length === 0 || pdfLoading ? 0.5 : 1,
//                       cursor:
//                         Selectlist.length === 0 || pdfLoading
//                           ? "not-allowed"
//                           : "pointer",
//                       pointerEvents:
//                         Selectlist.length === 0 || pdfLoading ? "none" : "auto",
//                     }}
//                   >
//                     <span>{isOptionClick ?`${t("Submit")}`:`${t("Print Preview")}`}</span>
//                   </div>
//                 </div>
//               </div>

//               <div
//                 className="main-body-main-table-wrap position-relative"
//                 style={{
//                   maxWidth: "100%",
//                   overflowX: viewMode === "table" ? "auto" : "visible",
//                 }}
//               >
//                 {viewMode !== "table" && (
//                   <div
//                     className={`row g-3 ${
//                       viewMode === "grid5"
//                         ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5"
//                         : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"
//                     }`}
//                   >
//                     {!datalodaer && inventorylist?.length
//                       ? inventorylist.map((result, key) => {
//                           console.log(
//                             result?.warranty_print,
//                             "result?.warranty_print",
//                           );
//                           return (
//                             <div className="col" key={key}>
//                               <div
//                                 style={{
//                                   position: "relative",
//                                   background: "#FFFFFF",
//                                   boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
//                                   borderRadius: "4px",
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     position: "relative",
//                                     width: "100%",
//                                     paddingBottom: "78%",
//                                     background: "#D9D9D9",
//                                     overflow: "hidden",
//                                     borderRadius: "4px 4px 0 0",
//                                   }}
//                                 >
//                                   <img
//                                     src={
//                                       result?.main_image ||
//                                       base_assets +
//                                         "images/icon/camera_profile.png"
//                                     }
//                                     alt=""
//                                     style={{
//                                       position: "absolute",
//                                       inset: 0,
//                                       width: "100%",
//                                       height: "100%",
//                                       cursor: "pointer",
//                                     }}
//                                     onError={(e) => {
//                                       e.target.onerror = null;
//                                       e.target.src =
//                                         "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
//                                     }}
//                                     onClick={() =>
//                                       setImageid(result?.product_id)
//                                     }
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductViewModal"
//                                   />
//                                   <HeldCheckbox
//                                     result={result}
//                                     wrapperStyle={{
//                                       position: "absolute",
//                                       left: "16px",
//                                       top: "13px",
//                                       zIndex: 2,
//                                     }}
//                                     wrapperClassName={
//                                       result?.is_adjustment_held
//                                         ? "com-check checkbox-disabled"
//                                         : "com-check"
//                                     }
//                                     inputClassName="inventorytablecheck gisClassTh"
//                                     onChange={(e) => handleChange(e)}
//                                     t={t}
//                                   />
//                                 </div>
//                                 <div
//                                   style={{
//                                     position: "absolute",
//                                     right: "16px",
//                                     top: "13px",
//                                     zIndex: 3,
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "2px",
//                                   }}
//                                 >
//                                   {result?.pos_Qty !== 0 &&
//                                   result?.pos?.order_type === "repair_order" ? (
//                                     <div
//                                       className="tooltip-area-up"
//                                       style={{ lineHeight: 0 }}
//                                     >
//                                       <img
//                                         src={
//                                           base_assets +
//                                           "images/icons/user-purple.png"
//                                         }
//                                         alt="repair order"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                         }}
//                                       />
//                                       <span className="tooltip-area-up-text">
//                                         {result?.customer_name}
//                                         {result?.customer_name ? <br /> : ""}
//                                         {result?.POS_Order}
//                                         {result?.POS_Order ? <br /> : ""}
//                                         {result?.delivery_date}
//                                       </span>
//                                     </div>
//                                   ) : result?.pos_Qty !== 0 ? (
//                                     <div
//                                       className="tooltip-area-up"
//                                       style={{ lineHeight: 0 }}
//                                       data-bs-toggle="modal"
//                                       data-bs-target="#allocation-listedModal"
//                                     >
//                                       <img
//                                         src={
//                                           base_assets +
//                                           "images/icons/user-red.png"
//                                         }
//                                         alt="custom order"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                         }}
//                                       />
//                                       <span className="tooltip-area-up-text">
//                                         {result?.customer_name}
//                                         {result?.customer_name ? <br /> : ""}
//                                         {result?.POS_Order}
//                                         {result?.POS_Order ? <br /> : ""}
//                                         {result?.delivery_date}
//                                       </span>
//                                     </div>
//                                   ) : null}
//                                 </div>
//                                 <div
//                                   style={{
//                                     padding: "14px 16px",
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "107.78px",
//                                   }}
//                                 >
//                                   <div>
//                                     <p
//                                       style={{
//                                         margin: 0,
//                                         fontFamily: "Segoe UI, sans-serif",
//                                         fontSize: "16px",
//                                         lineHeight: "21px",
//                                         color: "#A4A4A4",
//                                         overflow: "hidden",
//                                         textOverflow: "ellipsis",
//                                         whiteSpace: "nowrap",
//                                         cursor: "pointer",
//                                       }}
//                                       onClick={() => setOneproduct(result)}
//                                       data-bs-toggle="modal"
//                                       data-bs-target="#ProductInfoModal"
//                                     >
//                                       {result?.name || result?.item_name || ""}
//                                     </p>
//                                     <div
//                                       style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "6px",
//                                         marginTop: "4px",
//                                         overflow: "hidden",
//                                       }}
//                                     >
//                                       <p
//                                         style={{
//                                           margin: 0,
//                                           fontFamily: "Segoe UI, sans-serif",
//                                           fontWeight: 400,
//                                           fontSize: "14px",
//                                           lineHeight: "19px",
//                                           color: "#2A2A2A",
//                                           overflow: "hidden",
//                                           textOverflow: "ellipsis",
//                                           whiteSpace: "nowrap",
//                                           flexShrink: 0,
//                                           maxWidth: "50%",
//                                         }}
//                                       >
//                                         {result?.SKU || ""}
//                                       </p>
//                                       {result?.stock_id && (
//                                         <>
//                                           <span
//                                             style={{
//                                               color: "#E5E5E5",
//                                               flexShrink: 0,
//                                             }}
//                                           >
//                                             |
//                                           </span>
//                                           <p
//                                             style={{
//                                               margin: 0,
//                                               fontFamily:
//                                                 "Segoe UI, sans-serif",
//                                               fontWeight: 400,
//                                               fontSize: "14px",
//                                               lineHeight: "19px",
//                                               color: "#2A2A2A",
//                                               overflow: "hidden",
//                                               textOverflow: "ellipsis",
//                                               whiteSpace: "nowrap",
//                                             }}
//                                           >
//                                             {result?.stock_id}
//                                           </p>
//                                         </>
//                                       )}
//                                       {result?.location_name && (
//                                         <>
//                                           <span
//                                             style={{
//                                               color: "#E5E5E5",
//                                               flexShrink: 0,
//                                             }}
//                                           >
//                                             |
//                                           </span>
//                                           <p
//                                             style={{
//                                               margin: 0,
//                                               fontFamily:
//                                                 "Segoe UI, sans-serif",
//                                               fontWeight: 400,
//                                               fontSize: "14px",
//                                               lineHeight: "19px",
//                                               color: "#2A2A2A",
//                                               overflow: "hidden",
//                                               textOverflow: "ellipsis",
//                                               whiteSpace: "nowrap",
//                                             }}
//                                           >
//                                             {result?.location_name}
//                                           </p>
//                                         </>
//                                       )}
//                                     </div>
//                                   </div>
//                                   <div
//                                     style={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       marginTop: "10px",
//                                     }}
//                                   >
//                                     <span
//                                       style={{
//                                         fontFamily: "Segoe UI, sans-serif",
//                                         fontWeight: 400,
//                                         fontSize: "18px",
//                                         lineHeight: "24px",
//                                         color: "#2A2A2A",
//                                       }}
//                                     >
//                                       {result?.price || ""}
//                                     </span>
//                                     <div
//                                       className={`status-dot ${getStatusDotClass(result?.status_type)} tooltip-area-up ms-2`}
//                                       style={{
//                                         width: "13px",
//                                         height: "13px",
//                                         flexShrink: 0,
//                                       }}
//                                     >
//                                       <span className="tooltip-area-up-text">
//                                         {t(getStatusLabel(result?.status_type))}
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           );
//                         })
//                       : ""}
//                   </div>
//                 )}

//                 {viewMode === "table" && (
//                   <table
//                     id="my_inventory"
//                     className="stripe row-border order-column common-table table-striped main-table w-100"
//                   >
//                     <thead>
//                       <tr
//                         style={{
//                           borderTop: "1px solid #E3E3E3",
//                           borderBottom: "1px solid #E3E3E3",
//                         }}
//                       >
//                         <th
//                           ref={(el) => (stickyThRefs.current[0] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[0],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           <div className="com-check">
//                             <input
//                               checked={SelectAllStatus}
//                               id="th_comman_checkbox"
//                               onClick={(e) =>
//                                 setSelectAllStatus(e.target.checked)
//                               }
//                               className="inventorytableHead_main"
//                               data-select="inventorytableHead_main"
//                               type="checkbox"
//                             />
//                             <label
//                               htmlFor="th_comman_checkbox"
//                               className="com-check-label"
//                             />
//                           </div>
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[1] = el)}
//                           className="fixed-side"
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[1],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           #
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[2] = el)}
//                           className="fixed-side"
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[2],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Img")}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[3] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[3],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("SKU")}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[4] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[4],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         ></th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[5] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[5],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Item")}
//                           {renderColFilterDropdown("item", colDropdownRefItem)}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[6] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[6],
//                             zIndex: 3,
//                             background: "#fff",
//                           }}
//                         >
//                           {t("Collection")}
//                           {renderColFilterDropdown(
//                             "collection",
//                             colDropdownRefCollection,
//                           )}
//                         </th>
//                         <th
//                           ref={(el) => (stickyThRefs.current[7] = el)}
//                           style={{
//                             position: "sticky",
//                             left: stickyLefts[7],
//                             zIndex: 3,
//                             background: "#fff",
//                             boxShadow: "3px 0 5px -2px rgba(0,0,0,0.15)",
//                           }}
//                         >
//                           {t("Metal")}
//                           {renderColFilterDropdown(
//                             "metal",
//                             colDropdownRefMetal,
//                           )}
//                         </th>
//                         <th>
//                           {t("Stone")}
//                           {renderColFilterDropdown(
//                             "stone",
//                             colDropdownRefStone,
//                           )}
//                         </th>
//                         <th>
//                           {t("Size")}
//                           {renderColFilterDropdown("size", colDropdownRefSize)}
//                         </th>
//                         <th>{t("Stock ID")}</th>
//                         <th></th>
//                         <th></th>
//                         <th>{t("Qty")}</th>
//                         <th>{t("Price")}</th>
//                         <th>{t("Aging")}</th>
//                         <th>
//                           {t("Location")}
//                           {renderColFilterDropdown(
//                             "location",
//                             colDropdownRefLocation,
//                           )}
//                         </th>
//                         <th className="text-center">
//                           {t("Status")}
//                           {renderColFilterDropdown(
//                             "status",
//                             colDropdownRefStatus,
//                           )}
//                         </th>
//                         <th className="text-center">{t("POS Order")}</th>
//                         <th className="text-center">{t("Customer")}</th>
//                         <th className="text-center">{t("Delivery Date")}</th>
//                         <th className="text-center">{t("Due Days")}</th>
//                         <th>{t("Remark")}</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <>
//                         {!datalodaer && inventorylist?.length
//                           ? inventorylist.map((result, key) => {
//                               return (
//                                 <tr
//                                   key={key}
//                                   className=""
//                                   style={{ borderBottom: "1px solid #E3E3E3" }}
//                                 >
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[0],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <HeldCheckbox
//                                       result={result}
//                                       wrapperClassName={
//                                         result?.is_adjustment_held
//                                           ? "com-check checkbox-disabled"
//                                           : "com-check"
//                                       }
//                                       inputClassName="inventorytablecheck inventorytableHead gisClassTh"
//                                       onChange={(e) => handleChange(e)}
//                                       t={t}
//                                     />
//                                   </td>
//                                   <td
//                                     className="fixed-side"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[1],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     {parseInt(key + getSkipNumbers + 1)}
//                                   </td>
//                                   <td
//                                     className="table-pro-img"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[2],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                     onClick={() =>
//                                       setImageid(result?.product_id)
//                                     }
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductViewModal"
//                                   >
//                                     <img
//                                       src={
//                                         result?.main_image
//                                           ? result?.main_image
//                                           : base_assets +
//                                             "images/icon/camera_profile.png"
//                                       }
//                                       alt=""
//                                     />
//                                   </td>
//                                   <td
//                                     className="col-highlight"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[3],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductInfoModal"
//                                   >
//                                     {result?.SKU ? result?.SKU : ""}
//                                   </td>
//                                   <td
//                                     className="col-highlight"
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[4],
//                                       zIndex: 2,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#ProductInfoModal"
//                                   >
//                                     {result?.warranty_print ? (
//                                       <div className="tooltip-area-up">
//                                         <img
//                                           src={optionIcon}
//                                           alt="logo"
//                                           style={{
//                                             // width: "100%",
//                                             // height: "100%",
//                                             objectFit: "contain",
//                                           }}
//                                         />
//                                         {result?.warranty_print && (
//                                           <span className="tooltip-area-up-text">
//                                             {result?.warranty_print
//                                               ? "Reprint"
//                                               : ""}
//                                           </span>
//                                         )}
//                                       </div>
//                                     ) : undefined}
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[5],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.item_code
//                                         ? result?.item_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.item_name
//                                           ? result?.item_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[6],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.collection_code
//                                         ? result?.collection_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.collection_name
//                                           ? result?.collection_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td
//                                     style={{
//                                       position: "sticky",
//                                       left: stickyLefts[7],
//                                       zIndex: 1,
//                                       background:
//                                         key % 2 === 0 ? "#f2f2f2" : "#ffffff",
//                                       boxShadow:
//                                         "3px 0 5px -2px rgba(0,0,0,0.15)",
//                                     }}
//                                   >
//                                     <div className="tooltip-area-up">
//                                       {result?.metal_code
//                                         ? result?.metal_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.metal_name
//                                           ? result?.metal_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     <div className="tooltip-area-up">
//                                       {result?.stone_code
//                                         ? result?.stone_code
//                                         : ""}
//                                       <span className="tooltip-area-up-text">
//                                         {result?.stone_name
//                                           ? result?.stone_name
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.size_name ? result?.size_name : ""}
//                                   </td>
//                                   {result?.status_stock_id === "stock" ? (
//                                     <td className="light-blue-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id === "transit" ? (
//                                     <td className="status-green-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "warehouse" ? (
//                                     <td className="status-gray-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id === "reserve" ? (
//                                     <td className="yellow-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}{" "}
//                                           {result?.customer_name ? <br /> : ""}{" "}
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "repair_order" ? (
//                                     <td className="purple-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           {result?.POS_Order}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : result?.status_stock_id ===
//                                     "custom_order" ? (
//                                     <td className="danger-text col-highlight">
//                                       <div className="tooltip-area-up">
//                                         {result?.stock_id
//                                           ? result?.stock_id
//                                           : ""}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           {result?.POS_Order}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </td>
//                                   ) : (
//                                     ""
//                                   )}
//                                   <td className="col-highlight">
//                                     {result?.traceability_on ? (
//                                       <img
//                                         src={traceimg}
//                                         alt="trace_on"
//                                         data-bs-toggle="modal"
//                                         data-bs-target="#TraceabilityModal"
//                                         // onClick={() => handleTraceData(key)}
//                                       />
//                                     ) : (
//                                       ""
//                                     )}
//                                   </td>
//                                   <td
//                                     className="sku-col table_btn_expand_col col-highlight"
//                                     onClick={() => {
//                                       setProduct_id(result?.id);
//                                       setCart_id(result?.pos?.cart_id);
//                                     }}
//                                   >
//                                     {result?.allocatable === true ? (
//                                       <div className="td-icons-wrap m-3 d-inline-block">
//                                         <div className="td-icons-wrap-link">
//                                           <img
//                                             className="img"
//                                             src={
//                                               base_assets +
//                                               "images/icons/link-icon.svg"
//                                             }
//                                             alt=""
//                                           />
//                                         </div>
//                                       </div>
//                                     ) : (
//                                       ""
//                                     )}
//                                     <div className="td-icons-wrap-user d-inline-block">
//                                       {result?.pos_Qty !== 0 &&
//                                       result?.pos?.order_type ===
//                                         "repair_order" ? (
//                                         <div className="tooltip-area-up">
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-purple.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                           <span className="tooltip-area-up-text">
//                                             {result?.customer_name}
//                                             {result?.customer_name ? (
//                                               <br />
//                                             ) : (
//                                               ""
//                                             )}
//                                             {result?.POS_Order}
//                                             <br />
//                                             {result?.delivery_date}
//                                           </span>
//                                         </div>
//                                       ) : result?.pos_Qty !== 0 ? (
//                                         <div
//                                           className="tooltip-area-up"
//                                           data-bs-toggle="modal"
//                                           data-bs-target="#allocation-listedModal"
//                                         >
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-red.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                           <span className="tooltip-area-up-text">
//                                             {result?.customer_name}
//                                             {result?.customer_name ? (
//                                               <br />
//                                             ) : (
//                                               ""
//                                             )}
//                                             {result?.POS_Order}
//                                             <br />
//                                             {result?.delivery_date}
//                                           </span>
//                                         </div>
//                                       ) : (
//                                         ""
//                                       )}
//                                     </div>
//                                     <div className="td-icons-wrap-user d-inline-block">
//                                       <div className="tooltip-area-up">
//                                         {result?.status_type === "  " ? (
//                                           <div className="td-icons-wrap-user d-inline-block">
//                                             <img
//                                               className="img"
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/user-yellow.png"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                         ) : (
//                                           ""
//                                         )}
//                                         <span className="tooltip-area-up-text">
//                                           {result?.customer_name}
//                                           {result?.customer_name ? <br /> : ""}
//                                           <br />
//                                           {result?.delivery_date}
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.po_QTY ? result?.po_QTY : 0}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.price ? result?.price : ""}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.aging ? result?.aging : "0"}
//                                   </td>
//                                   <td className="location-td col-highlight">
//                                     <span className="link-color">
//                                       {result?.location_name
//                                         ? result?.location_name
//                                         : ""}
//                                     </span>
//                                     <span className="text-center location-td-sub">
//                                       {result?.warehouse_location_name
//                                         ? result?.warehouse_location_name
//                                         : ""}
//                                     </span>
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.status_type === "stock" ? (
//                                       <div className="status-dot light-blue-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Stock")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "transit" ? (
//                                       <div className="status-dot green-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Transit")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "warehouse" ? (
//                                       <div className="status-dot status-gray-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Warehouse")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type === "reserve" ? (
//                                       <div className="status-dot yellow-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Reserve")}
//                                         </span>
//                                       </div>
//                                     ) : result?.status_type ===
//                                       "repair_order" ? (
//                                       <div className="status-dot purple-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Repair Order")}
//                                         </span>
//                                       </div>
//                                     ) : (
//                                       <div className="status-dot danger-bg tooltip-area-up">
//                                         <span className="tooltip-area-up-text">
//                                           {t("Custom Order")}
//                                         </span>
//                                       </div>
//                                     )}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.POS_Order ? result?.POS_Order : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.customer_name
//                                       ? result?.customer_name
//                                       : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.delivery_date
//                                       ? result?.delivery_date
//                                       : ""}
//                                   </td>
//                                   <td className="text-danger col-highlight">
//                                     {result?.due_days ? result?.due_days : ""}
//                                   </td>
//                                   <td className="col-highlight">
//                                     {result?.remark ? result?.remark : "-"}
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                           : ""}
//                       </>
//                     </tbody>
//                     <tfoot>
//                       {!datalodaer && (
//                         <tr>
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td>{datatotal?.qty ? datatotal?.qty : 0}</td>
//                           <td>{datatotal?.amount ? datatotal?.amount : ""}</td>
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                           <td />
//                         </tr>
//                       )}
//                     </tfoot>
//                   </table>
//                 )}

//                 {datalodaer && <TableLoader />}
//               </div>

//               {inventorylist.length > 0 ? (
//                 <Pagination
//                   total={totalPages}
//                   current={currentPage}
//                   pagination={(crPage) => handlePaginations(crPage)}
//                 />
//               ) : (
//                 ""
//               )}
//             </div>{" "}
//           </div>{" "}
//         </div>{" "}
//       </div>{" "}
//     </React.Fragment>
//   );
// };

// export default WarrantyInv;



import React, { useRef, useState, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";
import { _Api, _PdfApi } from "../../../components/api/_call";
import "rc-slider/assets/index.css";
import { Pagination } from "../../../components/common/Pagination";
import {
  loading,
  Updateloading,
} from "../../../components/common/helpers/toastify";
import optionIcon from "../../../assets/images/icons/optionButton.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Select from "react-select";
import TableLoader from "../../../admin/common/TableLoader";
import traceimg from "../../../assets/images/TraceItem_diamond.svg";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import HeldCheckbox from "../../../components/common/modules/HeldCheckbox";

const WarrantyInv = (props) => {
  const { t } = useTranslation();
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const traceabilityEnabled = generalsettings?.data?.generalsetup?.traceability === "1";
  const dataFetched = useRef();
  const colDropdownRefItem = useRef(null);
  const colDropdownRefCollection = useRef(null);
  const colDropdownRefMetal = useRef(null);
  const colDropdownRefStone = useRef(null);
  const colDropdownRefSize = useRef(null);
  const colDropdownRefLocation = useRef(null);
  const colDropdownRefStatus = useRef(null);
  const colFilterTriggerRefs = useRef({});
  const stickyThRefs = useRef([]);
  const viewDropdownRef = useRef(null);
  const [openColFilter, setOpenColFilter] = useState(null);
  const [colFilterPortalStyle, setColFilterPortalStyle] = useState({});
  const [stickyLefts, setStickyLefts] = useState([
    0, 40, 80, 135, 250, 340, 445,
  ]);
  const [inventorylist, setInventorylist] = useState([]);
  const [inventorycounts, setInventorycounts] = useState();
  const [filterdata, setFilterdata] = useState();
  const [showoption, setShowoption] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [showpos, setShowpos] = useState([]);
  const [transferlist, setTransferlist] = useState([]);
  const [locationidlist, setLocationidlist] = useState([]);
  const [showtransfer, setShowtransfer] = useState(false);
  const [onlyTransfer, setOnlyTransfer] = useState(false);
  const [filtername, setFiltername] = useState("");
  const [limit, setLimit] = useState(100);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const [Selectlist, setSelectlist] = useState([]);
  const [getoneproduct, setOneproduct] = useState();
  const [imageid, setImageid] = useState();
  const [selectedlocation, setSelectedlocation] = useState();
  const [selectedwarehouse, setSelectedwarehouse] = useState("");
  const [product_id, setProduct_id] = useState();
  const [cart_id, setCart_id] = useState();
  const [getSkipNumbers, setSkipNumbers] = useState(0);
  const [datalodaer, setDatsLodaer] = useState(false);
  const [isOptionClick, setIsOptionClick] = useState(false);
  const [datatotal, setDatatotal] = useState({ amount: 0, qty: 0 });
  const [traceData, setTraceData] = useState();
  const [traceDetail, setTraceDetail] = useState({});
  const [payload, setPayload] = useState();
  const [invCount, setInvCount] = useState(0);
  const [viewMode, setViewMode] = useState("table");
  const [viewDropdownOpen, setViewDropdownOpen] = useState(false);
  const [colFilterOptions, setColFilterOptions] = useState({});
  const fullInventoryRef = useRef([]);

  const getStatusDotClass = (status) => {
    const map = {
      stock: "light-blue-bg",
      transit: "green-bg",
      warehouse: "status-gray-bg",
      reserve: "yellow-bg",
      repair_order: "purple-bg",
      custom_order: "danger-bg",
    };
    return map[status] || "light-blue-bg";
  };

  const getStatusLabel = (status) => {
    const map = {
      stock: "Stock",
      transit: "Transit",
      warehouse: "Warehouse",
      reserve: "Reserve",
      repair_order: "Repair Order",
      custom_order: "Custom Order",
    };
    return map[status] || status || "";
  };

  const [activeFilters, setActiveFilters] = useState({
    item: [],
    collection: [],
    metal: [],
    stone: [],
    size: [],
    location: [],
    status: [],
    price: [],
  });
  const [colFilterSearch, setColFilterSearch] = useState({
    item: "",
    collection: "",
    metal: "",
    stone: "",
    size: "",
    location: "",
    status: "",
  });

  // const iconMap = {
  //   "652e2c3f7ab8c5b2750a4f03": { icon: chain_origin, color: "#3484D4" },
  //   "652e2c3f7ab8c5b2750a4f04": { icon: chainrelated, color: "#3484D4" },
  //   "652e2c3f7ab8c5b2750a4f05": { icon: chainrelated, color: "#3484D4" },
  //   "652e2c3f7ab8c5b2750a4f08": { icon: diamond_mine, color: "#212121" },
  //   "652e2c3f7ab8c5b2750a4f09": { icon: diamondrelated, color: "#212121" },
  //   "652e2c3f7ab8c5b2750a4f06": { icon: diamondrelated, color: "#212121" },
  //   "652e2c3f7ab8c5b2750a4f07": { icon: diamondrelated, color: "#212121" },
  //   "652e2c3f7ab8c5b2750a4f0a": { icon: metal_origin, color: "#73AAE1" },
  //   "652e2c3f7ab8c5b2750a4f0b": { icon: handcrafting, color: "#87898C" },
  //   "652e2c3f7ab8c5b2750a4f0c": { icon: handcrafting, color: "#87898C" },
  //   "652e2c3f7ab8c5b2750a4f02": { icon: qc_shipping, color: "#73AB8B" },
  // };

  // const getTimelineData = (data) => {
  //   const timeline = [];

  //   timeline.push({
  //     id: "product_design",
  //     name: "Product Design",
  //     countries: [data?.product_design_trace ? data?.product_design_trace : []],
  //     transactionId: data?.product_design_trace_detail?.transactionId || "-",
  //     iconName: { icon: product_design, color: "#3C609C" },
  //   });

  //   const iconMapOrder = [
  //     "652e2c3f7ab8c5b2750a4f03",
  //     "652e2c3f7ab8c5b2750a4f04",
  //     "652e2c3f7ab8c5b2750a4f05",
  //     "652e2c3f7ab8c5b2750a4f08",
  //     "652e2c3f7ab8c5b2750a4f09",
  //     "652e2c3f7ab8c5b2750a4f06",
  //     "652e2c3f7ab8c5b2750a4f07",
  //     "652e2c3f7ab8c5b2750a4f0a",
  //     "652e2c3f7ab8c5b2750a4f0b",
  //     "652e2c3f7ab8c5b2750a4f0c",
  //     "652e2c3f7ab8c5b2750a4f02",
  //   ];

  //   const orderedItems = iconMapOrder
  //     .filter((key) => data.traceability[key])
  //     .map((key) => ({
  //       id: key,
  //       ...data.traceability[key],
  //       iconName: iconMap[key]
  //         ? iconMap[key]
  //         : {
  //             icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
  //             color: "#606060",
  //           },
  //     }));

  //   const unorderedItems = Object.keys(data.traceability)
  //     .filter((key) => !iconMapOrder.includes(key))
  //     .map((key) => ({
  //       id: key,
  //       ...data.traceability[key],
  //       iconName: iconMap[key]
  //         ? iconMap[key]
  //         : {
  //             icon: "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png",
  //             color: "#606060",
  //           },
  //     }));

  //   timeline.push(...orderedItems, ...unorderedItems);
  //   return timeline;
  // };

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const handleChange = (event) => {
    if (event.target.checked) {
      let posorderarray = [];
      const selected = [...Selectlist];
      const mainarray = [...inventorylist];
      const transferarray = [...transferlist];
      const locationarray = [...locationidlist];
      let checking = document.querySelectorAll(".inventorytablecheck");
      let hasOnlyTransfer = false;
      for (let i = 0; i < checking.length; i++) {
        if (checking[i].checked) {
          posorderarray.push(i);
          setShowoption(true);
          // if (
          //   checking[i].getAttribute("data-status") === "reserve" &&
          //   checking[i].getAttribute("data-isnottransferable") === "false"
          // ) {
          //   hasOnlyTransfer = true;
          // }
        }
        setShowpos(posorderarray);
      }
      setOnlyTransfer(hasOnlyTransfer);
      if (selected.filter((e) => e === event.target.id).length === 0) {
        selected.push(event.target.id);
      }
      setSelectlist(selected);
      const currentid = mainarray.filter((all) => all.id === event.target.id);
      setSelectedlocation(currentid[0]?.location_id);
      setSelectedwarehouse(
        currentid[0]?.warehouse_id ? currentid[0]?.warehouse_id : "null",
      );
      if (transferarray?.length === 0) {
        setShowtransfer(true);
        locationarray.push(currentid[0]?.location_id);
        setLocationidlist(locationarray);
        transferarray.push(event.target.id);
        setTransferlist(transferarray);
      } else {
        const checkloc = locationarray.filter(
          (locid) => locid === currentid[0]?.location_id,
        );
        if (checkloc?.length) {
          transferarray.push(event.target.id);
          setShowtransfer(true);
          setTransferlist(transferarray);
        } else {
          setShowtransfer(false);
        }
      }
    } else {
      let array = [];
      let posorderarray = [];
      const mainarray = [...inventorylist];
      const transferarray = [...transferlist];
      const locationarray = [...locationidlist];
      let checking = document.querySelectorAll(".inventorytablecheck");
      let hasOnlyTransfer = false;
      for (let i = 0; i < checking.length; i++) {
        if (checking[i].checked) {
          array.push(i);
          posorderarray.push(i);
          setShowoption(true);
          // if (
          //   checking[i].getAttribute("data-status") === "reserve" &&
          //   checking[i].getAttribute("data-isnottransferable") === "false"
          // ) {
          //   hasOnlyTransfer = true;
          // }
        }
        setShowpos(posorderarray);
      }
      setOnlyTransfer(hasOnlyTransfer);
      setSelectlist((current) =>
        current.filter((item) => item !== event.target.id),
      );
      if (array.length === 0) {
        setShowoption(false);
        setOnlyTransfer(false);
      }
      const currentid = mainarray.filter((all) => all.id === event.target.id);
      if (transferarray?.length === 1) {
        setLocationidlist((current) =>
          current.filter((item) => item !== currentid[0]?.location_id),
        );
        setTransferlist((current) =>
          current.filter((item) => item !== event.target.id),
        );
        setShowtransfer(true);
        setSelectedlocation("");
        setSelectedwarehouse("");
      } else {
        const checkloc = locationarray.filter(
          (locid) => locid === currentid[0]?.location_id,
        );
        if (checkloc?.length) {
          setTransferlist((current) =>
            current.filter((item) => item !== event.target.id),
          );
          var callcheck = document.querySelectorAll(".inventorytablecheck");
          for (var i = 0; i < callcheck.length; i++) {
            if (callcheck[i].checked) {
              let locationid = callcheck[i].getAttribute("data-locationid");
              const notmatch = locationarray.filter(
                (locid) => locid !== locationid,
              );
              if (notmatch.length) {
                setShowtransfer(false);
              } else {
                setShowtransfer(true);
              }
            }
          }
        } else {
          if (transferarray?.length) {
            setShowtransfer(true);
          } else {
            setShowtransfer(false);
          }
        }
      }
    }
  };

  const inventorycountsapi = async (filter, search) => {
    try {
      const postdata = { location: filter?.location ? filter?.location : [] };
      let res = await _Api(postdata, `api/v1/Inventory/my/inventory-statics`);
      if (res?.code === 200) {
        setInventorycounts(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const inventorylowercount = async (filter, search, limit) => {
    try {
      const postdata = {
        item: filter?.item ? filter?.item : [],
        collection: filter?.collection ? filter?.collection : [],
        metal: filter?.metal ? filter?.metal : [],
        size: filter?.size ? filter?.size : [],
        stone: filter?.stone ? filter?.stone : [],
        productStatus: filter?.status ? filter?.status : [],
        location: filter?.location ? filter?.location : [],
        price: filter?.price ? filter?.price : [],
        search: search === "" ? search : filtername,
        limit: limit,
        allocated: filter?.allocated ? filter?.allocated : false,
        traced: filter?.traced ? filter?.traced : false,
      };
      let res = await _Api(
        postdata,
        `api/v1/Inventory/my/inventory-lowerStatics`,
      );
      if (res?.code === 200) {
        setDatatotal(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getmyinventory(1, limit, filterdata, search, 0);
  };

  const getlimit = (limit) => {
    setLimit(limit);
    Getmyinventory(1, limit, filterdata);
    setstate({ ...state, currentPage: 1 });
  };

  const [state, setstate] = useState({ totalPages: 20, currentPage: 1 });
  const { totalPages, currentPage } = state;

  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getmyinventory(current, "", filterdata);
  };

  const Getmyinventory = useCallback(
    async (current, firstlimit, filter, search, skip) => {
      let tablelimit = 1;
      if (firstlimit === "ALL") {
        tablelimit = 1;
      } else {
        tablelimit = firstlimit ? firstlimit : limit;
      }
      setDatsLodaer(true);
      var skipNumber = current ? (current - 1) * tablelimit : 0;
      if (skip === 0 || skipNumber === 0) {
        inventorycountsapi(filter, search);
      }
      setInvCount(0);
      try {
        const postdata = {
          item: filter?.item ? filter?.item : [],
          collection: filter?.collection ? filter?.collection : [],
          metal: filter?.metal ? filter?.metal : [],
          size: filter?.size ? filter?.size : [],
          stone: filter?.stone ? filter?.stone : [],
          productStatus: filter?.status ? filter?.status : [],
          location: filter?.location ? filter?.location : [],
          price: filter?.price ? filter?.price : [],
          search: search === "" ? search : filtername,
          limit: firstlimit ? firstlimit : limit,
          skip: skip === 0 ? skip : skipNumber,
          allocated: filter?.allocated ? filter?.allocated : false,
          traced: filter?.traced ? filter?.traced : false,
        };
        setPayload(postdata);
        let resPoinventory = await _Api(postdata, `api/v1/Inventory/my/list`);
        if (resPoinventory?.code === 200) {
          setFilterdata(filter);
          setSelectAllStatus(false);
          setDatsLodaer(false);
          setSkipNumbers(skip === 0 ? skip : skipNumber);
          let pageini = 1;
          if (postdata.limit === "ALL") {
            pageini = resPoinventory?.total;
          } else {
            pageini = postdata.limit;
          }
          setstate({
            ...state,
            totalPages: Math.ceil(resPoinventory?.total / pageini),
            currentPage: current ? current : 1,
          });
          setInventorylist(resPoinventory?.data);
          fullInventoryRef.current = resPoinventory?.data;
          setInvCount(resPoinventory?.total);
          inventorylowercount(
            filter,
            search,
            parseInt(postdata?.limit) + parseInt(postdata?.skip),
          );
        }
      } catch (err) {
        console.log(err, "err");
      }
      // eslint-disable-next-line
    },
    [filtername, limit, state],
  );

  useEffect(() => {
    if (dataFetched.current) return;
    dataFetched.current = true;
    Getmyinventory();
    // eslint-disable-next-line
  }, [Getmyinventory]);

  // const handleTraceData = (key) => {
  //   const mainarray = [...inventorylist];
  //   const item = mainarray[key];
  //   const tracesDetail = {
  //     image: item?.main_image || "",
  //     name: item?.name || "",
  //     SKU: item?.SKU || "",
  //     pos_Qty: item?.po_QTY || 1,
  //     stock_id: item?.stock_id || "-",
  //     transactionId: item?.product_design_trace_detail?.transactionId,
  //   };
  //   setTraceDetail(tracesDetail);
  //   const traceability = item?.traceability || {};
  //   const product_design_trace = item?.product_design_trace || {
  //     label: "Unknown",
  //     value: "",
  //   };
  //   const product_design_trace_detail = item?.product_design_trace_detail || {
  //     transactionId: "-",
  //   };
  //   const tracesData = {
  //     traceability,
  //     product_design_trace,
  //     product_design_trace_detail,
  //   };
  //   const arrtrace = getTimelineData(tracesData);
  //   setTraceData(arrtrace);
  // };

  // useEffect(() => {
  //   if (SelectAllStatus) {
  //     let callcheck = document.querySelectorAll(".inventorytablecheck");
  //     const selected = [...Selectlist];
  //     const transferarray = [...transferlist];
  //     let location_id = [];
  //     let warehouse_id = [];
  //     for (let i = 0; i < callcheck.length; i++) {
  //       let status = callcheck[i].getAttribute("data-status");
  //       if (status === "reserve" || status === "transit") {
  //         callcheck[i].checked = false;
  //       }
  //       if (callcheck[i].checked) {
  //         let id = callcheck[i].getAttribute("data-id");
  //         let location = callcheck[i].getAttribute("data-locationid");
  //         let warehouse = callcheck[i].getAttribute("warehouse_id");
  //         location_id.push(location);
  //         warehouse_id.push(warehouse);
  //         if (selected.indexOf(id) === -1) {
  //           selected.push(id);
  //         }
  //         const array = Array.from(
  //           new Set(inventorylist.map((item) => item.location_id)),
  //         );
  //         if (array?.length === 1) {
  //           setShowtransfer(true);
  //           transferarray.push(id);
  //         }
  //       }
  //     }
  //     setSelectedlocation(location_id[0]);
  //     if (warehouse_id[0]) {
  //       setSelectedwarehouse(warehouse_id[0]);
  //     } else {
  //       setSelectedwarehouse("null");
  //     }
  //     setTransferlist(transferarray);
  //     setSelectlist(selected);
  //   } else {
  //     let callcheck = document.querySelectorAll(".inventorytablecheck");
  //     let newSelectlist = [...Selectlist];
  //     let newTransferlist = [...transferlist];
  //     for (let i = 0; i < callcheck.length; i++) {
  //       let id = callcheck[i].getAttribute("data-id");
  //       newSelectlist = newSelectlist.filter((item) => item !== id);
  //       newTransferlist = newTransferlist.filter((item) => item !== id);
  //     }
  //     setSelectlist(newSelectlist);
  //     setTransferlist(newTransferlist);
  //   }
  //   // eslint-disable-next-line
  // }, [SelectAllStatus, inventorylist]);

  useEffect(() => {
    if (SelectAllStatus) {
      const selected = [];
      const transferarray = [];
      const location_id = [];
      const warehouse_id = [];

      let callcheck = document.querySelectorAll(".inventorytablecheck");
      for (let i = 0; i < callcheck.length; i++) {
        // Rows held for Stock Adjustment can't be selected, even via "select all".
        const isHeld = callcheck[i].getAttribute("data-isadjustmentheld") === "true";
        if (isHeld) {
          callcheck[i].checked = false;
          continue;
        }
        callcheck[i].checked = true;

        const id = callcheck[i].getAttribute("data-id");
        const location = callcheck[i].getAttribute("data-locationid");
        const warehouse = callcheck[i].getAttribute("warehouse_id");

        location_id.push(location);
        warehouse_id.push(warehouse);
        if (id && !selected.includes(id)) selected.push(id);
        transferarray.push(id);
      }

      setSelectedlocation(location_id[0]);
      setSelectedwarehouse(warehouse_id[0] || "null");
      setTransferlist(transferarray);
      setSelectlist(selected);
      setShowoption(selected.length > 0);

      const uniqueLocs = Array.from(new Set(location_id));
      setShowtransfer(uniqueLocs.length === 1);
    } else {
      // Uncheck all DOM checkboxes
      document.querySelectorAll(".inventorytablecheck").forEach((cb) => {
        cb.checked = false;
      });
      setSelectlist([]);
      setTransferlist([]);
      setLocationidlist([]);
      setShowoption(false);
      setShowtransfer(false);
    }
  }, [SelectAllStatus, inventorylist]);
  useEffect(() => {
    const allCheckboxes = document.querySelectorAll(".inventorytablecheck");
    if (allCheckboxes.length === 0) return;

    // Rows held for Stock Adjustment are never selectable, so they must be
    // excluded from the "all selected" count too — otherwise the header
    // checkbox could never show as checked while any row is held.
    const selectableCount = inventorylist.filter(
      (r) => !r?.is_adjustment_held
    ).length;
    const allChecked =
      selectableCount > 0 && Selectlist.length === selectableCount;

    setSelectAllStatus(allChecked);
  }, [Selectlist, inventorylist]);

  useEffect(() => {
    getColFilterOptions();
  }, []);

  useEffect(() => {
    const computeStickyLefts = () => {
      let acc = 0;
      const lefts = stickyThRefs.current.map((th) => {
        const left = acc;
        if (th) acc += th.offsetWidth;
        return left;
      });
      setStickyLefts(lefts);
    };
    computeStickyLefts();
    window.addEventListener("resize", computeStickyLefts);
    return () => window.removeEventListener("resize", computeStickyLefts);
  }, [inventorylist]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        viewDropdownRef.current &&
        !viewDropdownRef.current.contains(e.target)
      ) {
        setViewDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getColFilterOptions = async () => {
    try {
      let res = await _Api(
        { custom_filter_enable: true },
        `api/v1/Inventory/my/filter`,
      );
      if (res?.code === 200) {
        setColFilterOptions(res?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  // Add this helper
  const resetAllCheckboxes = () => {
    document.querySelectorAll(".inventorytablecheck").forEach((cb) => {
      cb.checked = false;
    });
    const headerCb = document.getElementById("th_comman_checkbox");
    if (headerCb) headerCb.checked = false;
    setSelectlist([]);
    setSelectAllStatus(false);
    setTransferlist([]);
    setLocationidlist([]);
    setShowoption(false);
    setShowtransfer(false);
  };

  const handlePrintWarranty = async () => {
    if (!Selectlist.length) {
      toast.error("Please select at least one item to print.");
      return;
    }
    setPdfLoading(true);
    let GetloadingID = loading();
    try {
      const blobData = await _PdfApi(
        {
          po_product_ids: Selectlist,
          website_url: window.location.hostname,
          type: "",
          skip_logo_fetch: true,
        },
        "api/v1/APP/warranty/print",
      );
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");

      Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
    } catch (err) {
      console.error(err);
      Updateloading(t, GetloadingID, "Failed to generate print.", "e");
    } finally {
      resetAllCheckboxes();
      setPdfLoading(false);
    }
  };

  useEffect(() => {
    if (isOptionClick) {
      setInventorylist(
        fullInventoryRef.current.filter((i) => i.warranty_print === true),
      );
    } else {
      setInventorylist(fullInventoryRef.current);
    }
  }, [isOptionClick]);

  const hendleColDropdownHide = () => {
    setOpenColFilter(null);
  };

  const updateColFilterPortalPosition = (filterKey) => {
    const trigger = colFilterTriggerRefs.current[filterKey];
    if (!trigger) return;
    const rect = trigger.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const menuWidth = 286;
    let left = rect.left;
    if (left + menuWidth + 8 > viewportWidth) {
      left = Math.max(8, viewportWidth - menuWidth - 8);
    }
    setColFilterPortalStyle({
      position: "fixed",
      top: rect.bottom + 6,
      left,
      width: menuWidth,
      zIndex: 3000,
    });
  };

  useEffect(() => {
    if (!openColFilter) return undefined;
    updateColFilterPortalPosition(openColFilter);
    const handleReposition = () => updateColFilterPortalPosition(openColFilter);
    const refMap = {
      item: colDropdownRefItem,
      collection: colDropdownRefCollection,
      metal: colDropdownRefMetal,
      stone: colDropdownRefStone,
      size: colDropdownRefSize,
      location: colDropdownRefLocation,
      status: colDropdownRefStatus,
    };
    const handleOutsideClick = (event) => {
      const trigger = colFilterTriggerRefs.current[openColFilter];
      const menu = refMap[openColFilter]?.current;
      if (trigger?.contains(event.target) || menu?.contains(event.target)) {
        return;
      }
      setOpenColFilter(null);
    };
    window.addEventListener("resize", handleReposition);
    window.addEventListener("scroll", handleReposition, true);
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      window.removeEventListener("resize", handleReposition);
      window.removeEventListener("scroll", handleReposition, true);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openColFilter]);

  const handleColFilterItemChange = (event, value, filterKey) => {
    setActiveFilters((prev) => ({
      ...prev,
      [filterKey]: event.target.checked
        ? [...prev[filterKey], value]
        : prev[filterKey].filter((v) => v !== value),
    }));
  };

  const handleColFilterSelectAll = (event, filterKey) => {
    const isStatus = filterKey === "status";
    const allValues = (colFilterOptions?.[filterKey] || []).map((o) =>
      isStatus ? o.value : o._id,
    );
    setActiveFilters((prev) => ({
      ...prev,
      [filterKey]: event.target.checked ? allValues : [],
    }));
  };

  const applyColFilter = (filterKey) => {
    Getmyinventory(1, limit, activeFilters, filtername, 0);
    hendleColDropdownHide();
  };

  const renderColFilterDropdown = (filterKey, dropdownRef) => {
    const isStatus = filterKey === "status";
    const options = colFilterOptions?.[filterKey] || [];
    const checkedVals = activeFilters[filterKey] || [];
    const searchTerm = colFilterSearch[filterKey] || "";
    const filteredOptions = searchTerm
      ? options.filter((o) =>
          o?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : options;
    const isOpen = openColFilter === filterKey;

    const menuContent = (
      <div
        className="dropdown-menu show com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"
        style={colFilterPortalStyle}
        ref={dropdownRef}
        onClick={(e) => e.stopPropagation()}
      >
        {!isStatus && (
          <div className="com-custom-table-tag-filter-menu-search">
            <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
              <img src={base_assets + "images/icons/search-icon.png"} alt="" />
              <input
                className="border-0"
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) =>
                  setColFilterSearch((prev) => ({
                    ...prev,
                    [filterKey]: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        )}
        <div className="com-custom-table-tag-filter-menu-select">
          <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
            <div>
              <input
                className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                type="checkbox"
                id={`colfilter-all-${filterKey}`}
                onChange={(e) => handleColFilterSelectAll(e, filterKey)}
                checked={
                  options.length > 0 && checkedVals.length === options.length
                }
              />
              <label
                className="form-check-label cursor-pointer fw-semibold"
                htmlFor={`colfilter-all-${filterKey}`}
              >
                {t("Select All")}
              </label>
            </div>
            <label>
              {checkedVals.length}/{options.length} {t("Selected")}
            </label>
          </div>
          <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
            {filteredOptions.map((opt, idx) => {
              const val = isStatus ? opt.value : opt._id;
              const optId = `colfilter-${filterKey}-${idx}`;
              return (
                <li
                  className="com-custom-table-tag-filter-menu-select-list-single"
                  key={optId}
                >
                  <input
                    className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer"
                    type="checkbox"
                    id={optId}
                    checked={checkedVals.includes(val)}
                    onChange={(e) =>
                      handleColFilterItemChange(e, val, filterKey)
                    }
                  />
                  <label
                    className="form-check-label cursor-pointer"
                    htmlFor={optId}
                  >
                    {opt?.name}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
            onClick={() => {
              setActiveFilters((prev) => ({ ...prev, [filterKey]: [] }));
              setColFilterSearch((prev) => ({ ...prev, [filterKey]: "" }));
              Getmyinventory();
              hendleColDropdownHide();
            }}
          >
            {t("Clear")}
          </button>
          <button
            className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold"
            onClick={() => applyColFilter(filterKey)}
          >
            {t("Apply")}
          </button>
        </div>
      </div>
    );

    return (
      <div
        className="d-inline-block com-custom-table-tag-filter"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={(el) => {
            colFilterTriggerRefs.current[filterKey] = el;
          }}
          className="after-none bg-transparent border-0 p-0"
          type="button"
          aria-expanded={isOpen}
          onClick={() => {
            setOpenColFilter((prev) => {
              const next = prev === filterKey ? null : filterKey;
              if (next) {
                const trigger = colFilterTriggerRefs.current[filterKey];
                if (trigger) {
                  const rect = trigger.getBoundingClientRect();
                  const viewportWidth =
                    window.innerWidth || document.documentElement.clientWidth;
                  const menuWidth = 286;
                  let left = rect.left;
                  if (left + menuWidth + 8 > viewportWidth) {
                    left = Math.max(8, viewportWidth - menuWidth - 8);
                  }
                  setColFilterPortalStyle({
                    position: "fixed",
                    top: rect.bottom + 6,
                    left,
                    width: menuWidth,
                    zIndex: 3000,
                  });
                }
              }
              return next;
            });
          }}
        >
          <img
            className="ms-2 com-custom-table-tag-filter-img"
            src={base_assets + "images/icons/table-filter-icon.png"}
            alt=""
          />
        </button>
        {isOpen && createPortal(menuContent, document.body)}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="main-body my-inventory-page">
        <div className="container" style={{ padding: "46px 46px 0px" }}>
          <div className="row">
            <div className="col-lg-12">
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <Link to="/app/admin/setup/warranty">
                  <img
                    className="page-back-btn-inside-img"
                    src={base_assets + "/images/icons/arrow-left.png"}
                    alt="back"
                    style={{
                      width: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }}
                  />
                </Link>
                <h1 className="main-body-heading">{t("Import Inventory")}</h1>
              </div>

              <div
                className="main-body-top-status-bar"
                style={{ marginTop: 50 }}
              >
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
                <div className="main-body-top-status-bar-filter">
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t("SKU/StockID")}
                    onKeyPress={(e) =>
                      e.key === "Enter" && filterbyname(e.target.value)
                    }
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  <button
                    onClick={filterbyname}
                    className="main-body-top-status-bar-filter-search"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginLeft: "auto",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <div className="tooltip-area-up">
                    <div
                      className="inventory-btn"
                      style={{
                        display: "flex",
                        gap: "3px",
                        fontSize: "14px",
                        alignItems: "center",
                        background: isOptionClick ? "#D8F3F2" : "transparent",
                        border: isOptionClick ? "1px solid #62D0CB" : "unset",
                        padding: isOptionClick ? "0px 12px" : "unset",
                      }}
                      onClick={() => setIsOptionClick(!isOptionClick)}
                    >
                      <img
                        src={optionIcon}
                        alt="logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                      />
                      {isOptionClick
                        ? fullInventoryRef.current.filter(
                            (i) => i.warranty_print === true,
                          )?.length
                        : undefined}
                    </div>
                    <span className="tooltip-area-up-text">{t("Reprint Filter")}</span>
                  </div>

                  <div
                    className="inventory-btn"
                    onClick={() =>
                      !pdfLoading ? handlePrintWarranty() : undefined
                    }
                    style={{
                      opacity: Selectlist.length === 0 || pdfLoading ? 0.5 : 1,
                      cursor:
                        Selectlist.length === 0 || pdfLoading
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents:
                        Selectlist.length === 0 || pdfLoading ? "none" : "auto",
                    }}
                  >
                    <span>{isOptionClick ?`${t("Submit")}`:`${t("Print Preview")}`}</span>
                  </div>
                </div>
              </div>

              <div
                className="main-body-main-table-wrap position-relative"
                style={{
                  maxWidth: "100%",
                  overflowX: viewMode === "table" ? "auto" : "visible",
                }}
              >
                {viewMode !== "table" && (
                  <div
                    className={`row g-3 ${
                      viewMode === "grid5"
                        ? "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5"
                        : "row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"
                    }`}
                  >
                    {!datalodaer && inventorylist?.length
                      ? inventorylist.map((result, key) => {
                          console.log(
                            result?.warranty_print,
                            "result?.warranty_print",
                          );
                          return (
                            <div className="col" key={key}>
                              <div
                                style={{
                                  position: "relative",
                                  background: "#FFFFFF",
                                  boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                                  borderRadius: "4px",
                                }}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    paddingBottom: "78%",
                                    background: "#D9D9D9",
                                    overflow: "hidden",
                                    borderRadius: "4px 4px 0 0",
                                  }}
                                >
                                  <img
                                    src={
                                      result?.main_image ||
                                      base_assets +
                                        "images/icon/camera_profile.png"
                                    }
                                    alt=""
                                    style={{
                                      position: "absolute",
                                      inset: 0,
                                      width: "100%",
                                      height: "100%",
                                      cursor: "pointer",
                                    }}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                    }}
                                    onClick={() =>
                                      setImageid(result?.product_id)
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductViewModal"
                                  />
                                  <HeldCheckbox
                                    result={result}
                                    wrapperStyle={{
                                      position: "absolute",
                                      left: "16px",
                                      top: "13px",
                                      zIndex: 2,
                                    }}
                                    wrapperClassName={
                                      result?.is_adjustment_held
                                        ? "com-check checkbox-disabled"
                                        : "com-check"
                                    }
                                    inputClassName="inventorytablecheck gisClassTh"
                                    onChange={(e) => handleChange(e)}
                                    t={t}
                                  />
                                </div>
                                <div
                                  style={{
                                    position: "absolute",
                                    right: "16px",
                                    top: "13px",
                                    zIndex: 3,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2px",
                                  }}
                                >
                                  {result?.pos_Qty !== 0 &&
                                  result?.pos?.order_type === "repair_order" ? (
                                    <div
                                      className="tooltip-area-up"
                                      style={{ lineHeight: 0 }}
                                    >
                                      <img
                                        src={
                                          base_assets +
                                          "images/icons/user-purple.png"
                                        }
                                        alt="repair order"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}
                                        {result?.customer_name ? <br /> : ""}
                                        {result?.POS_Order}
                                        {result?.POS_Order ? <br /> : ""}
                                        {result?.delivery_date}
                                      </span>
                                    </div>
                                  ) : result?.pos_Qty !== 0 ? (
                                    <div
                                      className="tooltip-area-up"
                                      style={{ lineHeight: 0 }}
                                      data-bs-toggle="modal"
                                      data-bs-target="#allocation-listedModal"
                                    >
                                      <img
                                        src={
                                          base_assets +
                                          "images/icons/user-red.png"
                                        }
                                        alt="custom order"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      <span className="tooltip-area-up-text">
                                        {result?.customer_name}
                                        {result?.customer_name ? <br /> : ""}
                                        {result?.POS_Order}
                                        {result?.POS_Order ? <br /> : ""}
                                        {result?.delivery_date}
                                      </span>
                                    </div>
                                  ) : null}
                                </div>
                                <div
                                  style={{
                                    padding: "14px 16px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    minHeight: "107.78px",
                                  }}
                                >
                                  <div>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontFamily: "Segoe UI, sans-serif",
                                        fontSize: "16px",
                                        lineHeight: "21px",
                                        color: "#A4A4A4",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => setOneproduct(result)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#ProductInfoModal"
                                    >
                                      {result?.name || result?.item_name || ""}
                                    </p>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        marginTop: "4px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <p
                                        style={{
                                          margin: 0,
                                          fontFamily: "Segoe UI, sans-serif",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          lineHeight: "19px",
                                          color: "#2A2A2A",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          flexShrink: 0,
                                          maxWidth: "50%",
                                        }}
                                      >
                                        {result?.SKU || ""}
                                      </p>
                                      {result?.stock_id && (
                                        <>
                                          <span
                                            style={{
                                              color: "#E5E5E5",
                                              flexShrink: 0,
                                            }}
                                          >
                                            |
                                          </span>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontFamily:
                                                "Segoe UI, sans-serif",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                              lineHeight: "19px",
                                              color: "#2A2A2A",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {result?.stock_id}
                                          </p>
                                        </>
                                      )}
                                      {result?.location_name && (
                                        <>
                                          <span
                                            style={{
                                              color: "#E5E5E5",
                                              flexShrink: 0,
                                            }}
                                          >
                                            |
                                          </span>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontFamily:
                                                "Segoe UI, sans-serif",
                                              fontWeight: 400,
                                              fontSize: "14px",
                                              lineHeight: "19px",
                                              color: "#2A2A2A",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {result?.location_name}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "Segoe UI, sans-serif",
                                        fontWeight: 400,
                                        fontSize: "18px",
                                        lineHeight: "24px",
                                        color: "#2A2A2A",
                                      }}
                                    >
                                      {result?.price || ""}
                                    </span>
                                    <div
                                      className={`status-dot ${getStatusDotClass(result?.status_type)} tooltip-area-up ms-2`}
                                      style={{
                                        width: "13px",
                                        height: "13px",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <span className="tooltip-area-up-text">
                                        {t(getStatusLabel(result?.status_type))}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </div>
                )}

                {viewMode === "table" && (
                  <table
                    id="my_inventory"
                    className="stripe row-border order-column common-table table-striped main-table w-100"
                  >
                    <thead>
                      <tr
                        style={{
                          borderTop: "1px solid #E3E3E3",
                          borderBottom: "1px solid #E3E3E3",
                        }}
                      >
                        <th
                          ref={(el) => (stickyThRefs.current[0] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[0],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          <div className="com-check">
                            <input
                              checked={SelectAllStatus}
                              id="th_comman_checkbox"
                              onClick={(e) =>
                                setSelectAllStatus(e.target.checked)
                              }
                              className="inventorytableHead_main"
                              data-select="inventorytableHead_main"
                              type="checkbox"
                            />
                            <label
                              htmlFor="th_comman_checkbox"
                              className="com-check-label"
                            />
                          </div>
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[1] = el)}
                          className="fixed-side"
                          style={{
                            position: "sticky",
                            left: stickyLefts[1],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          #
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[2] = el)}
                          className="fixed-side"
                          style={{
                            position: "sticky",
                            left: stickyLefts[2],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Img")}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[3] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[3],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("SKU")}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[4] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[4],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        ></th>
                        <th
                          ref={(el) => (stickyThRefs.current[5] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[5],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Item")}
                          {renderColFilterDropdown("item", colDropdownRefItem)}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[6] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[6],
                            zIndex: 3,
                            background: "#fff",
                          }}
                        >
                          {t("Collection")}
                          {renderColFilterDropdown(
                            "collection",
                            colDropdownRefCollection,
                          )}
                        </th>
                        <th
                          ref={(el) => (stickyThRefs.current[7] = el)}
                          style={{
                            position: "sticky",
                            left: stickyLefts[7],
                            zIndex: 3,
                            background: "#fff",
                            boxShadow: "3px 0 5px -2px rgba(0,0,0,0.15)",
                          }}
                        >
                          {t("Metal")}
                          {renderColFilterDropdown(
                            "metal",
                            colDropdownRefMetal,
                          )}
                        </th>
                        <th>
                          {t("Stone")}
                          {renderColFilterDropdown(
                            "stone",
                            colDropdownRefStone,
                          )}
                        </th>
                        <th>
                          {t("Size")}
                          {renderColFilterDropdown("size", colDropdownRefSize)}
                        </th>
                        <th>{t("Stock ID")}</th>
                        <th></th>
                        <th></th>
                        <th>{t("Qty")}</th>
                        <th>{t("Price")}</th>
                        <th>{t("Aging")}</th>
                        <th>
                          {t("Location")}
                          {renderColFilterDropdown(
                            "location",
                            colDropdownRefLocation,
                          )}
                        </th>
                        <th className="text-center">
                          {t("Status")}
                          {renderColFilterDropdown(
                            "status",
                            colDropdownRefStatus,
                          )}
                        </th>
                        <th className="text-center">{t("POS Order")}</th>
                        <th className="text-center">{t("Customer")}</th>
                        <th className="text-center">{t("Delivery Date")}</th>
                        <th className="text-center">{t("Due Days")}</th>
                        <th>{t("Remark")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {!datalodaer && inventorylist?.length
                          ? inventorylist.map((result, key) => {
                              return (
                                <tr
                                  key={key}
                                  className=""
                                  style={{ borderBottom: "1px solid #E3E3E3" }}
                                >
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[0],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <HeldCheckbox
                                      result={result}
                                      wrapperClassName={
                                        result?.is_adjustment_held
                                          ? "com-check checkbox-disabled"
                                          : "com-check"
                                      }
                                      inputClassName="inventorytablecheck inventorytableHead gisClassTh"
                                      onChange={(e) => handleChange(e)}
                                      t={t}
                                    />
                                  </td>
                                  <td
                                    className="fixed-side"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[1],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    {parseInt(key + getSkipNumbers + 1)}
                                  </td>
                                  <td
                                    className="table-pro-img"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[2],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                    onClick={() =>
                                      setImageid(result?.product_id)
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductViewModal"
                                  >
                                    <img
                                      src={
                                        result?.main_image
                                          ? result?.main_image
                                          : base_assets +
                                            "images/icon/camera_profile.png"
                                      }
                                      alt=""
                                    />
                                  </td>
                                  <td
                                    className="col-highlight"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[3],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductInfoModal"
                                  >
                                    {result?.SKU ? result?.SKU : ""}
                                  </td>
                                  <td
                                    className="col-highlight"
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[4],
                                      zIndex: 2,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#ProductInfoModal"
                                  >
                                    {result?.warranty_print ? (
                                      <div className="tooltip-area-up">
                                        <img
                                          src={optionIcon}
                                          alt="logo"
                                          style={{
                                            // width: "100%",
                                            // height: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                        {result?.warranty_print && (
                                          <span className="tooltip-area-up-text">
                                            {result?.warranty_print
                                              ? "Reprint"
                                              : ""}
                                          </span>
                                        )}
                                      </div>
                                    ) : undefined}
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[5],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.item_code
                                        ? result?.item_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.item_name
                                          ? result?.item_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[6],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.collection_code
                                        ? result?.collection_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.collection_name
                                          ? result?.collection_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: stickyLefts[7],
                                      zIndex: 1,
                                      background:
                                        key % 2 === 0 ? "#f2f2f2" : "#ffffff",
                                      boxShadow:
                                        "3px 0 5px -2px rgba(0,0,0,0.15)",
                                    }}
                                  >
                                    <div className="tooltip-area-up">
                                      {result?.metal_code
                                        ? result?.metal_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.metal_name
                                          ? result?.metal_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="col-highlight">
                                    <div className="tooltip-area-up">
                                      {result?.stone_code
                                        ? result?.stone_code
                                        : ""}
                                      <span className="tooltip-area-up-text">
                                        {result?.stone_name
                                          ? result?.stone_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="col-highlight">
                                    {result?.size_name ? result?.size_name : ""}
                                  </td>
                                  {result?.status_stock_id === "stock" ? (
                                    <td className="light-blue-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id === "transit" ? (
                                    <td className="status-green-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "warehouse" ? (
                                    <td className="status-gray-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id === "reserve" ? (
                                    <td className="yellow-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}{" "}
                                          {result?.customer_name ? <br /> : ""}{" "}
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "repair_order" ? (
                                    <td className="purple-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          {result?.POS_Order}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : result?.status_stock_id ===
                                    "custom_order" ? (
                                    <td className="danger-text col-highlight">
                                      <div className="tooltip-area-up">
                                        {result?.stock_id
                                          ? result?.stock_id
                                          : ""}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          {result?.POS_Order}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  <td className="col-highlight">
                                    {traceabilityEnabled && result?.traceability_on ? (
                                      <img
                                        src={traceimg}
                                        alt="trace_on"
                                        data-bs-toggle="modal"
                                        data-bs-target="#TraceabilityModal"
                                        // onClick={() => handleTraceData(key)}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td
                                    className="sku-col table_btn_expand_col col-highlight"
                                    onClick={() => {
                                      setProduct_id(result?.id);
                                      setCart_id(result?.pos?.cart_id);
                                    }}
                                  >
                                    {result?.allocatable === true ? (
                                      <div className="td-icons-wrap m-3 d-inline-block">
                                        <div className="td-icons-wrap-link">
                                          <img
                                            className="img"
                                            src={
                                              base_assets +
                                              "images/icons/link-icon.svg"
                                            }
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    <div className="td-icons-wrap-user d-inline-block">
                                      {result?.pos_Qty !== 0 &&
                                      result?.pos?.order_type ===
                                        "repair_order" ? (
                                        <div className="tooltip-area-up">
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-purple.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <span className="tooltip-area-up-text">
                                            {result?.customer_name}
                                            {result?.customer_name ? (
                                              <br />
                                            ) : (
                                              ""
                                            )}
                                            {result?.POS_Order}
                                            <br />
                                            {result?.delivery_date}
                                          </span>
                                        </div>
                                      ) : result?.pos_Qty !== 0 ? (
                                        <div
                                          className="tooltip-area-up"
                                          data-bs-toggle="modal"
                                          data-bs-target="#allocation-listedModal"
                                        >
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-red.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                          <span className="tooltip-area-up-text">
                                            {result?.customer_name}
                                            {result?.customer_name ? (
                                              <br />
                                            ) : (
                                              ""
                                            )}
                                            {result?.POS_Order}
                                            <br />
                                            {result?.delivery_date}
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    <div className="td-icons-wrap-user d-inline-block">
                                      <div className="tooltip-area-up">
                                        {result?.status_type === "  " ? (
                                          <div className="td-icons-wrap-user d-inline-block">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-yellow.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        <span className="tooltip-area-up-text">
                                          {result?.customer_name}
                                          {result?.customer_name ? <br /> : ""}
                                          <br />
                                          {result?.delivery_date}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="col-highlight">
                                    {result?.po_QTY ? result?.po_QTY : 0}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.price ? result?.price : ""}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.aging ? result?.aging : "0"}
                                  </td>
                                  <td className="location-td col-highlight">
                                    <span className="link-color">
                                      {result?.location_name
                                        ? result?.location_name
                                        : ""}
                                    </span>
                                    <span className="text-center location-td-sub">
                                      {result?.warehouse_location_name
                                        ? result?.warehouse_location_name
                                        : ""}
                                    </span>
                                  </td>
                                  <td className="col-highlight">
                                    {result?.status_type === "stock" ? (
                                      <div className="status-dot light-blue-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Stock")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "transit" ? (
                                      <div className="status-dot green-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Transit")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "warehouse" ? (
                                      <div className="status-dot status-gray-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Warehouse")}
                                        </span>
                                      </div>
                                    ) : result?.status_type === "reserve" ? (
                                      <div className="status-dot yellow-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Reserve")}
                                        </span>
                                      </div>
                                    ) : result?.status_type ===
                                      "repair_order" ? (
                                      <div className="status-dot purple-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Repair Order")}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="status-dot danger-bg tooltip-area-up">
                                        <span className="tooltip-area-up-text">
                                          {t("Custom Order")}
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.POS_Order ? result?.POS_Order : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.customer_name
                                      ? result?.customer_name
                                      : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.delivery_date
                                      ? result?.delivery_date
                                      : ""}
                                  </td>
                                  <td className="text-danger col-highlight">
                                    {result?.due_days ? result?.due_days : ""}
                                  </td>
                                  <td className="col-highlight">
                                    {result?.remark ? result?.remark : "-"}
                                  </td>
                                </tr>
                              );
                            })
                          : ""}
                      </>
                    </tbody>
                    <tfoot>
                      {!datalodaer && (
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>{datatotal?.qty ? datatotal?.qty : 0}</td>
                          <td>{datatotal?.amount ? datatotal?.amount : ""}</td>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                          <td />
                        </tr>
                      )}
                    </tfoot>
                  </table>
                )}

                {datalodaer && <TableLoader />}
              </div>

              {inventorylist.length > 0 ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </React.Fragment>
  );
};

export default WarrantyInv;
